module.exports = __webpack_public_path__ + "static/img/headBgc.78a01212.png";